import React from 'react'

import UserOutlined from '@ant-design/icons/UserOutlined'
import { Dropdown } from 'antd'
import { DropDownProps } from 'antd/lib/dropdown'

import { FlexBoxX } from 'common/components/boxes'

export type UserMenuProps = {
  userName: string
} & DropDownProps

export const UserMenu = ({ userName, ...props }: UserMenuProps) => {
  return (
    <Dropdown trigger={['click']} placement="topRight" {...props}>
      <FlexBoxX alignItems="center" flexGrow={0}>
        <UserOutlined />
        <FlexBoxX ml="12px">{userName}</FlexBoxX>
      </FlexBoxX>
    </Dropdown>
  )
}
